import { combine, createEvent, createStore, sample } from 'effector'

import { noop } from '~/shared/effector'
import { persist } from 'effector-storage/local'
import { model as session } from '~/entities/session'
import { MAX_AUTO_QUALITY } from '@setplex/player'

export const selectMaxAutoQualityAuto = createEvent<void>()
export const selectMaxAutoQualityLow = createEvent<void>()
export const selectMaxAutoQualityMedium = createEvent<void>()
export const selectMaxAutoQualityHigh = createEvent<void>()

export const $selectedMaxAutoQuality = createStore<
  Record<string, MAX_AUTO_QUALITY>
>({})

sample({
  clock: selectMaxAutoQualityAuto,
  source: {
    selectedMaxAutoQuality: $selectedMaxAutoQuality,
    session: session.$session,
  },
  filter: ({ session }) => session != null,
  fn: ({ selectedMaxAutoQuality, session }) => ({
    ...selectedMaxAutoQuality,
    [session!.accountNumber]: MAX_AUTO_QUALITY.AUTO,
  }),
  target: $selectedMaxAutoQuality,
})

sample({
  clock: selectMaxAutoQualityLow,
  source: {
    selectedMaxAutoQuality: $selectedMaxAutoQuality,
    session: session.$session,
  },
  filter: ({ session }) => session != null,
  fn: ({ selectedMaxAutoQuality, session }) => ({
    ...selectedMaxAutoQuality,
    [session!.accountNumber]: MAX_AUTO_QUALITY.LOW,
  }),
  target: $selectedMaxAutoQuality,
})

sample({
  clock: selectMaxAutoQualityMedium,
  source: {
    selectedMaxAutoQuality: $selectedMaxAutoQuality,
    session: session.$session,
  },
  filter: ({ session }) => session != null,
  fn: ({ selectedMaxAutoQuality, session }) => ({
    ...selectedMaxAutoQuality,
    [session!.accountNumber]: MAX_AUTO_QUALITY.MEDIUM,
  }),
  target: $selectedMaxAutoQuality,
})

sample({
  clock: selectMaxAutoQualityHigh,
  source: {
    selectedMaxAutoQuality: $selectedMaxAutoQuality,
    session: session.$session,
  },
  filter: ({ session }) => session != null,
  fn: ({ selectedMaxAutoQuality, session }) => ({
    ...selectedMaxAutoQuality,
    [session!.accountNumber]: MAX_AUTO_QUALITY.HIGH,
  }),
  target: $selectedMaxAutoQuality,
})

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  store: $selectedMaxAutoQuality,
  key: 'tria__max_auto_quality',
  fail: noop,
})

export const $currentMaxAutoQuality = combine(
  $selectedMaxAutoQuality,
  session.$session,
  (selectedMaxAutoQuality, session) => {
    const accountNumber = session?.accountNumber
    if (!accountNumber) return MAX_AUTO_QUALITY.AUTO
    return selectedMaxAutoQuality[accountNumber] || MAX_AUTO_QUALITY.AUTO
  }
)

export const $isMaxAutoQualityAuto = combine(
  $currentMaxAutoQuality,
  (currentMaxAutoQuality) => currentMaxAutoQuality === MAX_AUTO_QUALITY.AUTO
)
export const $isMaxAutoQualityLow = combine(
  $currentMaxAutoQuality,
  (currentMaxAutoQuality) => currentMaxAutoQuality === MAX_AUTO_QUALITY.LOW
)
export const $isMaxAutoQualityMedium = combine(
  $currentMaxAutoQuality,
  (currentMaxAutoQuality) => currentMaxAutoQuality === MAX_AUTO_QUALITY.MEDIUM
)
export const $isMaxAutoQualityHigh = combine(
  $currentMaxAutoQuality,
  (currentMaxAutoQuality) => currentMaxAutoQuality === MAX_AUTO_QUALITY.HIGH
)
